var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"scroll-text-gradient"},[_c('div',{staticClass:"text-container"},_vm._l((_vm.textList),function(text,index){return _c('div',{key:index,ref:`text-${index}`,refInFor:true,staticClass:"gradient-text",style:(_vm.getTextStyles(index))},[_vm._v(" "+_vm._s(text)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }